import React from 'react';
import { Switch, Route } from "react-router";
import Main from './Main/Main'
import MainBG from './MainBG/MainBG'
import Login from './Login/Login'
import CreateAccount from './CreateAccount/CreateAccount'
import ForgotPassword from './ForgotPassword/ForgotPassword'
import Home from './Home/Home'
import Lessons from './Lessons/Lessons'
import Prelude from './Prelude/Prelude'
import LearningUnit from './LearningUnit/LearningUnit'

const COMP_NAME = "App"

function App()
{
    console.log(COMP_NAME + ".constructor: ")
    return (
        <Switch>
            <Route key="1" exact path="/Login" component={Login} />
            <Route key="2" exact path="/CreateAccount" component={CreateAccount} />
            <Route key="3" exact path="/ForgotPassword" component={ForgotPassword} />
            <Route key="4" exact path="/Home" component={Home} />
            <Route key="5" exact path="/Lessons" component={Lessons} />
            <Route key="6" exact path="/Prelude" component={Prelude} />
            <Route key="7" exact path="/LearningUnit" component={LearningUnit} />
            <Route key="99" exact path="/MainBG" component={MainBG} />
            <Route key="1000" path="*" component={Main} /> {/* The Default not found component */}
        </Switch>
    );
}

export default App;

